import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { db } from "../../FirebaseConfig";
import { collection, getDocs, query, where } from "firebase/firestore";
import { getBaseURL } from "../../lib/getBaseURL";
import { useNavigate, useParams } from "react-router-dom";
import { UserAuth } from "../../Context";
import { useFetchUserData } from "../../hooks/user/useFetchUserData";
import AddToFavorites from "../ProfileShoppingList/AddToFavorites";
import ShopListMoreUserProfile from "../../ShoppingList/ShopListMoreUserProfile";
import FavoritesMoreUserProfile from "./FavoritesMoreUserProfile";
const FavoritesPostCard = ({ list, BackgroundOnSvg }) => {
  const [productDetails, setProductDetails] = useState([]);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const { uid } = useParams();
  const baseURL = getBaseURL();
  const { user } = UserAuth();
  const { userData } = useFetchUserData(uid);
  const navigate = useNavigate();
  console.log("list", list);
  // console.log("userData", userData);

  useEffect(() => {
    const fetchProductDetails = async () => {
      if (!list?.products || list.products.length === 0) return;
      // setLoading(true);
      try {
        const limitedProducts = list.products.slice(0, 4);
        const productIds = limitedProducts
          .map((product) => product.id)
          .filter(Boolean);

        if (productIds.length === 0) return;

        const productsRef = collection(db, "products");
        const q = query(productsRef, where("id", "in", productIds));
        const querySnapshot = await getDocs(q);

        const details = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setProductDetails(details);
        // setLoading(false);
      } catch (error) {
        console.error("Error fetching product details with in query:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchProductDetails();
  }, [list]);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isSingleProduct = list?.products?.length === 1;
  return (
    <>
      <div
        className={``}
        style={{
          padding: "8px 4px",
          position: "relative",
        }}
      >
        <style jsx>
          {`
            .shopListName:hover {
              color: var(--bs-link-hover-color);
            }
            .dropdown-toggle::after {
              display: none;
            }
            .profileShoppingListModal .modal-dialog {
              // max-width: 58.5rem;
              max-width: 63.5rem;
            }
          `}
        </style>

        {user?.uid !== uid && (
          <div
            style={{
              position: "absolute",
              bottom: isSmallScreen ? "1.5rem" : "4.25rem",
              right: isSmallScreen ? "1.5rem" : "0.7rem",
              zIndex: 2,
              width: "24px",
              height: "24px",
              backgroundColor: "#FFFFFF",
              borderRadius: "50%",
            }}
            className="d-flex justify-content-center align-items-center"
          >
            <AddToFavorites
              list={list}
              listName={list.name}
              myName={user?.displayName}
              listLink={`${baseURL}/#/shoppingList/${list.listId}/${uid}`}
              listId={list.listId}
              userId={user?.uid}
              products={list.products}
              componentName={"Favorites"}
              BackgroundOnSvg={BackgroundOnSvg}
              type={"postedShoppingList"}
            />
          </div>
        )}

        {/* Images */}
        <div
          className="d-flex p-0  w-100"
          style={{
            cursor: list?.products?.length > 0 ? "pointer" : "default",
            gap: "1px",
          }}
          onClick={() => {
            navigate(`/postedlist/${list.id}`);
          }}
        >
          {/* Main Image */}
          {list?.products?.length === 0 ? (
            <div
              className="d-flex w-100"
              style={{ gap: "1px", cursor: "pointer" }}
            >
              <div
                className="d-flex flex-column align-items-center justify-content-center"
                style={{
                  height: "239px",
                  width: "62.5%",
                  backgroundColor: "#F4F4F4",
                  borderTopLeftRadius: "6px",
                  gap: "12px",
                }}
              >
                <svg
                  width="70"
                  height="70"
                  viewBox="0 0 90 90"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="2"
                    y="2"
                    width="86"
                    height="86"
                    rx="43"
                    stroke="white"
                    stroke-width="4"
                  />
                  <path
                    d="M38.9292 30.9243C38.9292 28.1127 41.465 25.8334 44.5932 25.8334C47.7212 25.8334 50.2572 28.1127 50.2572 30.9243C50.2572 32.2476 49.7791 33.4529 48.9468 34.3582C47.353 36.0922 44.9708 37.8386 44.9708 40.088V40.8464M44.9708 40.8464C46.9215 40.8238 48.8799 41.3656 50.5255 42.475L56.1668 46.2776M44.9708 40.8464C43.0362 40.8688 41.1092 41.4467 39.5028 42.5766L20.581 55.8867C17.1887 58.2728 19.0661 63.1667 23.3736 63.1667H67.6268C71.9815 63.1667 73.8292 58.184 70.3455 55.8358L64.1668 51.6707"
                    stroke="white"
                    stroke-width="4"
                    stroke-linecap="round"
                  />
                </svg>
                <div
                  style={{
                    fontFamily: "Inter",
                    fontWeight: "400",
                    fontSize: "13px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                    textAlign: "center",
                  }}
                >
                  No products yet
                </div>
              </div>
              <div
                className="d-flex flex-column"
                style={{ width: "37.5%", gap: "1px" }}
              >
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    height: "79px",
                    backgroundColor: "#F4F4F4",
                    borderTopRightRadius: "6px",
                  }}
                >
                  <svg
                    width="44"
                    height="32"
                    viewBox="0 0 44 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.0718 5.81818C17.0718 3.70946 18.9736 2 21.3198 2C23.6658 2 25.5678 3.70946 25.5678 5.81818C25.5678 6.81064 25.2092 7.71466 24.585 8.39364C23.3896 9.69412 21.603 11.0039 21.603 12.691V13.2598M21.603 13.2598C23.066 13.2428 24.5348 13.6492 25.769 14.4812L30 17.3332M21.603 13.2598C20.152 13.2766 18.7068 13.71 17.502 14.5574L3.31062 24.54C0.76644 26.3296 2.17442 30 5.40508 30H38.595C41.861 30 43.2468 26.263 40.634 24.5018L36 21.378"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    height: "79px",
                    backgroundColor: "#F4F4F4",
                  }}
                >
                  <svg
                    width="44"
                    height="32"
                    viewBox="0 0 44 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.0718 5.81818C17.0718 3.70946 18.9736 2 21.3198 2C23.6658 2 25.5678 3.70946 25.5678 5.81818C25.5678 6.81064 25.2092 7.71466 24.585 8.39364C23.3896 9.69412 21.603 11.0039 21.603 12.691V13.2598M21.603 13.2598C23.066 13.2428 24.5348 13.6492 25.769 14.4812L30 17.3332M21.603 13.2598C20.152 13.2766 18.7068 13.71 17.502 14.5574L3.31062 24.54C0.76644 26.3296 2.17442 30 5.40508 30H38.595C41.861 30 43.2468 26.263 40.634 24.5018L36 21.378"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    height: "79px",
                    backgroundColor: "#F4F4F4",
                  }}
                >
                  <svg
                    width="44"
                    height="32"
                    viewBox="0 0 44 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.0718 5.81818C17.0718 3.70946 18.9736 2 21.3198 2C23.6658 2 25.5678 3.70946 25.5678 5.81818C25.5678 6.81064 25.2092 7.71466 24.585 8.39364C23.3896 9.69412 21.603 11.0039 21.603 12.691V13.2598M21.603 13.2598C23.066 13.2428 24.5348 13.6492 25.769 14.4812L30 17.3332M21.603 13.2598C20.152 13.2766 18.7068 13.71 17.502 14.5574L3.31062 24.54C0.76644 26.3296 2.17442 30 5.40508 30H38.595C41.861 30 43.2468 26.263 40.634 24.5018L36 21.378"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          ) : (
            <div
              // className="w-100"
              style={{
                position: "relative",
                height: "240px",
                width: isSingleProduct
                  ? "100%"
                  : list?.products?.length === 2
                  ? "50%"
                  : "62.5%",
              }}
            >
              <Card.Img
                // variant="top"
                // className="rounded-start"
                src={productDetails?.[0]?.imageUrl}
                // alt="No products to show"
                style={{
                  objectFit: "cover",
                  objectPosition: "top",
                  height: "99%",
                  borderTopLeftRadius: "6px",
                  borderTopRightRadius: isSingleProduct ? "6px" : "0",
                  // border: "1px solid #D6DADC",
                }}
              />
            </div>
          )}
          {/* Second Images */}
          {list?.products?.length > 3 ? (
            // More than 3 products: Show 3 stacked images
            <div
              className="d-flex flex-column"
              style={{ width: "37.5%", gap: "1px" }}
            >
              {/* 1st image */}
              <div>
                <Card.Img
                  variant="top"
                  src={productDetails?.[1]?.imageUrl}
                  style={{
                    objectFit: "cover",
                    height: "78.67px",
                    borderTopRightRadius: "6px",
                    borderBottomRightRadius: 0,
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    // border: "1px solid #D6DADC",
                  }}
                />
              </div>
              {/* 2nd image */}
              <div>
                <Card.Img
                  variant="top"
                  src={productDetails?.[2]?.imageUrl}
                  style={{
                    objectFit: "cover",
                    height: "78.67px",
                    borderRadius: 0,
                    // border: "1px solid #D6DADC",
                  }}
                />
              </div>
              {/* 3rd image */}
              <div>
                <Card.Img
                  variant="top"
                  src={productDetails?.[3]?.imageUrl}
                  style={{
                    objectFit: "cover",
                    height: "78.67px",
                    borderRadius: 0,
                    // border: "1px solid #D6DADC",
                  }}
                />
              </div>
            </div>
          ) : list?.products?.length > 2 ? ( // Three Images
            <div
              className="d-flex flex-column "
              style={{ width: "37.5%", gap: "1px" }}
            >
              {/* 1st image */}
              <div>
                <Card.Img
                  // variant="top"
                  src={productDetails?.[1]?.imageUrl}
                  style={{
                    objectFit: "cover",
                    height: "119px",
                    borderRadius: 0,
                    borderTopRightRadius: "6px",
                    // border: "1px solid #D6DADC",
                  }}
                />
              </div>
              {/* 2nd image */}
              <div style={{ position: "relative" }}>
                <Card.Img
                  // variant="top"
                  src={productDetails?.[2]?.imageUrl}
                  style={{
                    objectFit: "cover",
                    height: "119px",
                    borderRadius: 0,
                    // border: "1px solid #D6DADC",
                  }}
                />
              </div>
            </div>
          ) : (
            list?.products?.length > 1 && ( // Two Images
              <div
                style={{
                  position: "relative",
                  height: "15rem",
                  width: "50%",
                }}
              >
                <Card.Img
                  variant="top"
                  // className="rounded-2"
                  src={productDetails?.[1]?.imageUrl}
                  style={{
                    objectFit: "cover",
                    width: "100%",
                    height: "99%",
                    objectPosition: "top",
                    borderTopRightRadius: "6px",
                    borderBottomRightRadius: 0,
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    // border: "1px solid #D6DADC",
                  }}
                />
              </div>
            )
          )}
        </div>
        <div
          className="d-flex justify-content-between align-items-center w-100"
          style={{
            // cursor: "pointer",
            borderRadius: "0px 0px 6px 6px",
            borderWidth: "0px 1px 1px 1px",
            borderStyle: "solid",
            borderColor: "#0000001A",
            padding: "6px 4px",
          }}
        >
          <div
            className="d-flex flex-column"
            style={{
              width: "100%",
              gap: "4px",
            }}
          >
            <div
              className="text-truncate"
              title={list?.name}
              style={{
                cursor: "pointer",
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "100%",
                color: "black",
                width: "205px",
              }}
              onClick={() => {
                navigate(`/postedlist/${list.id}`);
              }}
            >
              {list?.name}
            </div>
            <div
              className="text-truncate"
              style={{
                cursor: "pointer",
                fontFamily: "Inter",
                fontWeight: 400,
                fontSize: "14px",
                color: "#667085",
                width: "100%",
              }}
              onClick={() => {
                navigate(`/postedlist/${list.id}`);
              }}
            >
              {list?.products?.length} item
              {list?.products?.length > 1 ? "s" : ""} •{" "}
              {list?.reactionCount ?? 0} Like
              {list?.reactionCount > 1 && "s"} • {list?.commentCount ?? 0}{" "}
              Comment
              {list?.commentCount > 1 && "s"}
            </div>
          </div>
          <FavoritesMoreUserProfile
            list={list}
            listId={list.listId}
            userId={user?.uid}
            listLink={`${baseURL}/#/postedlist/${list.id}`}
            BackgroundOnSvg={BackgroundOnSvg}
            imageWidth="28px"
            svgWidth="20px"
            showShareButton={true}
            type={"Post"}
            name={list?.name}
          />
        </div>
      </div>
    </>
  );
};

export default FavoritesPostCard;
